import { urbanColors } from "@urbaninstitute/dataviz-components/utils";

export const MAP_COLORS = [
  urbanColors.blue_shade_lightest,
  urbanColors.blue_shade_light,
  urbanColors.blue,
  urbanColors.blue_shade_darker,
  urbanColors.blue_shade_darkest
];

export const CHART_COLORS_SIMPLE = [urbanColors.blue, urbanColors.yellow];

// export const CHART_COLORS_SUBCATS = [
//   urbanColors.blue_shade_lightest,
//   urbanColors.blue_shade_lighter,
//   urbanColors.blue,
//   urbanColors.blue_shade_dark,
//   urbanColors.blue_shade_darker,
//   urbanColors.yellow,
//   urbanColors.yellow_shade_lighter
// ];
export const CHART_COLORS_SUBCATS = [
  urbanColors.blue_shade_darker,
  urbanColors.blue_shade_dark,
  urbanColors.blue,
  urbanColors.blue_shade_lighter,
  urbanColors.blue_shade_lightest,
  urbanColors.yellow,
  urbanColors.yellow_shade_lighter
];
